import {Divider, Image, Slot, Text, Trail, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React, {memo, useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {PhoneInput, TextInput} from '../../../../components/mobile'
import {EventGoal, useFormUserEventHandler} from '../../../../lib/metrika'
import {tagToUrl} from '../../../../lib/tagToUrl'
import {SwitchControlled} from '../Controlled/Switch'
import {useContact} from './Contact.hooks'
import type {Props} from './Contact.types'
import * as classes from './Details.classes'

export const ContactDetails = memo((props: Props): React.ReactElement => {
  const {labelPhone, labelName, names, isSource, smsTitle, smsSubtitle} = useContact(props)
  const {control} = useFormContext()
  const {
    fieldState: {error: phoneError, invalid: phoneInvalid},
  } = useController({name: names.phone, control})

  const handleReachGoal = useFormUserEventHandler()

  const handleFocus = useCallback(() => {
    handleReachGoal(isSource ? EventGoal.AddressFromPhoneClick : EventGoal.AddressToPhoneClick)
  }, [handleReachGoal, isSource])

  return (
    <Paper className={classes.detailsWrapper} padding="S">
      <PhoneInput
        className={classes.suggest}
        label={labelPhone}
        lead={<Image height={parseInt(spacing(3))} src={tagToUrl('image_user_round_fill')} />}
        name={names.phone}
        onFocus={handleFocus}
        size="l"
        variant="line"
      />
      <div className={classes.inputsWrapper}>
        <Divider isInvalid={phoneInvalid} />
        {phoneInvalid && (
          <Typography className={classes.errorMessage} color="error" variant="caption2">
            {phoneError?.message}
          </Typography>
        )}
        <TextInput label={labelName} name={names.name} size="l" variant="line" />
        <Slot Component="label">
          <Text style={{padding: 0}}>
            <Typography variant="body2">{smsTitle}</Typography>
            <Typography color="minor" variant="caption1">
              {smsSubtitle}
            </Typography>
          </Text>
          <Trail>
            <SwitchControlled name={names.sms} />
          </Trail>
        </Slot>
      </div>
    </Paper>
  )
})
